import { Component, OnInit, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import * as ngswal from "sweetalert";
import { GlobalConstants } from '../../common/global-constants';
import { customfunctions, DataParam } from '../../common/customfunctions';
import { ApiMethod } from '../../apimethods/api-method';
import { HttpClient, HttpXhrBackend } from '@angular/common/http';

import * as Highcharts from 'highcharts';
import Exporting from 'highcharts/modules/exporting';
import OfflineExporting from 'highcharts/modules/offline-exporting';

import { EmpGraphComponent } from './emp-graph/emp-graph.component';

declare var $;

Exporting(Highcharts);
OfflineExporting(Highcharts);;

@Component({
  selector: 'app-emp-occupancy',
  templateUrl: './emp-occupancy.component.html',
  styleUrls: ['./emp-occupancy.component.css']
})
/** emp-occupancy component*/
export class EmpOccupancyComponent implements OnInit {
  /** emp-occupancy ctor */

  currentYear: number = new Date().getFullYear();
  startYear: number = 2024; // Adjust as needed
  years: number[] = [];
  months = GlobalConstants.monthList;

  dataSet: any; dataTable: any; dtOptions: any; tableData = [];
  @ViewChild('dataTable', { static: false }) table;

  dataSetPM: any; dataTablePM: any; dtOptionsPM: any; tableDataPM = [];
  @ViewChild('dataTablePM', { static: false }) tablePM;

  dataSetTrans: any; dataTableTrans: any; dtOptionsTrans: any; tableDataTrans = [];
  @ViewChild('dataTableTrans', { static: false }) tableTrans;

  dataSetTrans1: any; dataTableTrans1: any; dtOptionsTrans1: any; tableDataTrans1 = [];
  @ViewChild('dataTableTrans1', { static: false }) tableTrans1;

  dataSetTrans2: any; dataTableTrans2: any; dtOptionsTrans2: any; tableDataTrans2 = [];
  @ViewChild('dataTableTrans2', { static: false }) tableTrans2;

  dataSetTrans3: any; dataTableTrans3: any; dtOptionsTrans3: any; tableDataTrans3 = [];
  @ViewChild('dataTableTrans3', { static: false }) tableTrans3;

  dataSetEmp: any; dataTableEmp: any;
  dtOptionsEmp: any; tableDataEmp = [];
  @ViewChild('dataTableEmp', { static: false }) tableEmp;

  dataSetPerfMatrixEmp: any; dataTablePerfMatrixEmp: any;
  dtOptionsPerfMatrixEmp: any; tableDataPerfMatrixEmp = [];
  @ViewChild('dataTablePerfMatrixEmp', { static: false }) tablePerfMatrixEmp;

  @ViewChild('empachieved') _empachieved!: EmpGraphComponent;
  @ViewChild('empoccupancy') _empoccupancy!: EmpGraphComponent;
  @ViewChild('emppunctuality') _emppunctuality!: EmpGraphComponent;
  @ViewChild('empattendance') _empattendance!: EmpGraphComponent;
  @ViewChild('empoverall') _empoverall!: EmpGraphComponent;


  departmentList: any; roleList: any;
  buuserList: any; userList: any;

  constructor() {
    this.years = Array.from({ length: this.currentYear - this.startYear + 1 }, (_, i) => this.startYear + i);
  }

  ngOnInit(): void {
    $('#divGraphPagination').hide();
    this.ResizeHieght();
    this.ChangeRange();
    this.GetDepartmentList();
    this.FetchGraphDashboad();
    this.GetDashboardLoad();


    setInterval(function () {
      //if ($('#myModalTrans').is(':visible')) {
      $($.fn.dataTable.tables(true)).DataTable().columns.adjust();
      //}
    }, 200);

  }

  MainTabChange(tabName) {
    $('#divPerfMatrixEmp').hide();
    $('#divPopupTab,#ulPopupTabList').show();

    if (tabName != 'Dashboard') {
      $('#divPopupTab,#ulPopupTabList').hide();
      $('#divPerfMatrixEmp').show();
    }
    //$('#ulPopupTabList').show();
    $($.fn.dataTable.tables(true)).DataTable().columns.adjust();
    $('#divGraphPagination').hide();
    if (tabName == 'KPI') {
      $('#divGraphPagination').show();
    }
    //if (tabName == 'PerfMartix') {
    //  $('#ulPopupTabList').hide();
    //}
  }

  onFromYearChange(event: Event): void {
    if ($('#ddlToYear').val() != '0') {
      $('#ddlToYear').val(0).change();
    }
  }

  onToYearChange(event: Event): void {
    if ($('#ddlFromYear').val() > $('#ddlToYear').val() && $('#ddlToYear').val() != 0) {
      ngswal("Failed !", 'Invalid to year', "warning");
      $('#ddlToYear').val(0).change();
    }
  }

  onFromMonthChange(event: Event): void {
    if ($('#ddlToMonth').val() != '0') {
      $('#ddlToMonth').val(0).change();
    }
  }

  onToMonthChange(event: Event): void {
    if ($('#ddlFromMonth').val() > $('#ddlToMonth').val() && $('#ddlToMonth').val() != 0) {
      ngswal("Failed !", 'Invalid to month', "warning");
      $('#ddlToMonth').val(0).change();
    }
  }


  ChangeRange() {
    customfunctions.SetDateValuesRangebased("#txtFromDt", "#txtToDt", $('#ddlRange').val());

    $('.divYear select').val(0).change(); $('.divMonth select').val(0).change();
    $('.divYear').hide(); $('.divMonth').hide(); $('.divDate').hide();
    if ($('#ddlRange').val() == 'Yearly') {
      $('.divYear').show();
    }
    if ($('#ddlRange').val() == 'Monthly') {
      $('.divMonth').show();
    }
    if ($('#ddlRange').val() == 'Custom') {
      $('.divDate').show();
    }
  }

  ResizeHieght() {
    $('#tabKPI').css('height', (GlobalConstants.size.height) - 50);
    $('#divFilterPanel').css('height', (GlobalConstants.size.height));
  }

  ResetPanelFilter() {
    $('#ddlRole,#ddlBUHead,#ddlUserList').val(0).change();
    this.GetDashboardLoad();
  }

  ngAfterViewChecked(): void {

  }

  GetUserBUHead() {
    $("#LoadingImage").hide();
    var dataparam = {
      LoginId: localStorage.aLoginID,
      PublisherId: localStorage.aPubID,
      RoleId: $('#ddlRole').val(),
      ManagerId: localStorage.aLoginID,
      ManagerId1: localStorage.aLoginID,
      UserType: 'BUHead',
      DepartmentId: $('#ddlDepartment').val()
    };
    ApiMethod.postMethod('api/occupancyusers', dataparam).subscribe(
      result => {
        $("#LoadingImage").hide();
        this.buuserList = result.dataList;
        this.GetRoleList();
        this.GetUserList();
      }, error => {
        $("#LoadingImage").hide();
        ngswal("Failed !", error.message, "warning");
      });
  }

  GetDepartmentList() {
    $("#LoadingImage").hide();
    var dataparam = {
      LoginId: localStorage.aLoginID
    };

    ApiMethod.postMethod('api/occupancydepartment', dataparam).subscribe(
      result => {
        $("#LoadingImage").hide();
        this.departmentList = result.dataList;
      }, error => {
        $("#LoadingImage").hide();
        ngswal("Failed !", error.message, "warning");
      });
  }

  GetRoleList() {
    $("#LoadingImage").hide();
    var dataparam = {
      LoginId: localStorage.aLoginID,
      DepartmentId: $('#ddlDepartment').val()
    };

    ApiMethod.postMethod('api/occupancyroles', dataparam).subscribe(
      result => {
        $("#LoadingImage").hide();
        this.roleList = result.dataList;
        this.GetUserList();
      }, error => {
        $("#LoadingImage").hide();
        ngswal("Failed !", error.message, "warning");
      });
  }

  GetUserList() {
    $("#LoadingImage").hide();
    var dataparam = {
      LoginId: localStorage.aLoginID,
      PublisherId: localStorage.aPubID,
      RoleId: $('#ddlRole').val(),
      ManagerId: $('#ddlBUHead').val(),
      ManagerId1: $('#ddlUserList').val(),
      UserType: 'User',
      DepartmentId: $('#ddlDepartment').val()
    };

    ApiMethod.postMethod('api/occupancyusers', dataparam).subscribe(
      result => {
        $("#LoadingImage").hide();
        this.userList = result.dataList;
      }, error => {
        $("#LoadingImage").hide();
        ngswal("Failed !", error.message, "warning");
      });
  }

  showTransModal: boolean;
  HideTransData() {
    $('#myModalTrans').hide();
  }


  PopupTabClick() {
    try {
      $($.fn.dataTable.tables(true)).DataTable().columns.adjust();
    } catch (e) {
    }
  }

  ShowUserDatewiseData() {

    $($.fn.dataTable.tables(true)).DataTable().columns.adjust();

    $('#LoadingImagePopup').show();
    var dataparam = {
      LoginId: localStorage.aLoginID,
      PublisherId: localStorage.aPubID,
      UserId: localStorage.aEID,
      ManagerId: $('#ddlBUHead').val(),
      ManagerId1: 0,
      RoleId: $('#ddlRole').val(),
      FromDate: $('#txtFromDt').val(),
      ToDate: $('#txtToDt').val(),
      Range: $('#ddlRange').val(),
      DepartmentId: $('#ddlDepartment').val(),
      ActiveTab: $('#ulTabList .nav-link.active')[0].name
    };

    $('#tabDatewise #dataTables').DataTable().clear().destroy();
    $('#tabDatewise #DataTables_Table_0').DataTable().destroy();
    $('#tabDatewise #DataTables_Table_0').empty();

    ApiMethod.postMethod('api/occupancydashboarddatewise', dataparam).subscribe(
      result => {
        $("#LoadingImagePopup").hide();
        if (result.message = 'Success') {

          this.dataSetEmp = JSON.stringify(result.dataList); // Data List
          this.dataSetEmp = JSON.parse(this.dataSetEmp);
          this.dataTableEmp = $(this.tableEmp.nativeElement);


          this.dataSetPerfMatrixEmp = JSON.stringify(result.dataList); // Data List
          this.dataSetPerfMatrixEmp = JSON.parse(this.dataSetPerfMatrixEmp);
          this.dataTablePerfMatrixEmp = $(this.tablePerfMatrixEmp.nativeElement);

          try {

            //Dynamic datable
            let aColList = result.colList;
            let dataItem = new DataParam();
            dataItem.acolList = aColList;
            dataItem.dataTable = this.dataTableEmp;
            dataItem.defaultPagesize = -1;
            dataItem.dataset = this.dataSetEmp;
            dataItem.dtheight = (GlobalConstants.size.height - 250);
            dataItem.modulename = 'EmpOccupancyEmpDatewise';
            dataItem.LengthChange = false;
            dataItem.colsetting = false;
            dataItem.infoPopupID = "UserId";
            dataItem.HideFreshButton = true;
            dataItem.HideUploadButton = true;
            /*dataItem.FooterCallback = true;
            dataItem.FooterSummaryStartIndex = 2;
            dataItem.FooterSummaryEndIndex = 10;
            dataItem.FooterSummaryAvgStart = 5;
            dataItem.FooterSummaryAvgEnd = 10;*/
            this.dataTableEmp = customfunctions.dynamicDataTable(dataItem);
            //Dynamic datable


            //Dynamic datable
            let aColList1 = result.colList1;
            let dataItem1 = new DataParam();
            dataItem1.acolList = aColList1;
            dataItem1.dataTable = this.dataTablePerfMatrixEmp;
            dataItem1.defaultPagesize = -1;
            dataItem1.dataset = this.dataSetPerfMatrixEmp;
            dataItem1.dtheight = (GlobalConstants.size.height - 250);
            dataItem1.modulename = 'EmpOccupancyEmpDatewise1';
            dataItem1.LengthChange = false;
            dataItem1.colsetting = false;
            dataItem1.infoPopupID = "UserId";
            dataItem1.HideFreshButton = true;
            dataItem1.HideUploadButton = true;
            this.dataTablePerfMatrixEmp = customfunctions.dynamicDataTable(dataItem1);
            //Dynamic datable

            $($.fn.dataTable.tables(true)).DataTable().columns.adjust();
          } catch (e) {

          }
        }
        else {
          ngswal("Failed !", result.message, "warning");
        }

      }, error => {
        $("#LoadingImagePopup").hide();
        ngswal("Failed !", error.message, "warning");
      });


  }

  showInfoPopUp(): void {
    let _colName = localStorage.dtColName;
    if (_colName != null) {
      _colName = _colName.replace('100', '');
    }

    this.ShowUserDatewiseData();

    $('#ulPopupTabList a[href="#tabTrans"]').trigger('click');

    $('#divTransData').html('');
    $("#LoadingImagePopup").show();
    var dataparam = {
      LoginId: localStorage.aLoginID,
      UserId: localStorage.aEID,
      PublisherId: localStorage.aPubID,
      FromDate: $('#txtFromDt').val(),
      ToDate: $('#txtToDt').val(),
      Range: $('#ddlRange').val(),
      InfoType: _colName,
    };
    ApiMethod.postMethod('api/GetProdctivityInfo', dataparam).subscribe(
      result => {

        $('#divTransData').html('');
        let dataValue = result.dataList;
        if (result.status == 'Success') {

          $('#tabTrans .tbTrans').hide();
          $(`#tabTrans .${_colName}`).show();

          this.dataSetTrans = JSON.stringify(result.dataList); this.dataSetTrans = JSON.parse(this.dataSetTrans);
          this.dataTableTrans = $(this.tableTrans.nativeElement);

          this.dataSetTrans1 = JSON.stringify(result.dataList); this.dataSetTrans1 = JSON.parse(this.dataSetTrans1);
          this.dataTableTrans1 = $(this.tableTrans1.nativeElement);

          this.dataSetTrans2 = JSON.stringify(result.dataList); this.dataSetTrans2 = JSON.parse(this.dataSetTrans2);
          this.dataTableTrans2 = $(this.tableTrans2.nativeElement);

          this.dataSetTrans3 = JSON.stringify(result.dataList); this.dataSetTrans3 = JSON.parse(this.dataSetTrans3);
          this.dataTableTrans3 = $(this.tableTrans3.nativeElement);

          //Dynamic datable
          let aColList = result.colList;
          let dataItem = new DataParam();
          dataItem.acolList = aColList;
          dataItem.defaultPagesize = -1;
          dataItem.dtheight = (GlobalConstants.size.height - 250);
          dataItem.modulename = `EmpOccupancy_${_colName}`;
          dataItem.LengthChange = false;
          dataItem.colsetting = false;
          dataItem.HideFreshButton = true;
          dataItem.HideUploadButton = true;
          $('#divTransTitle').html(GlobalConstants.GetTitleFormat(`${_colName} Summary`));

          if (_colName == "ProductivtyAchieved") {
            dataItem.dataTable = this.dataTableTrans;
            dataItem.dataset = this.dataSetTrans;
            this.dataTableTrans = customfunctions.dynamicDataTable(dataItem);
          }
          else if (_colName == "Punctuality") {
            dataItem.dataTable = this.dataTableTrans1;
            dataItem.dataset = this.dataSetTrans1;
            this.dataTableTrans1 = customfunctions.dynamicDataTable(dataItem);
          }
          else if (_colName == "Attendance") {
            dataItem.dataTable = this.dataTableTrans2;
            dataItem.dataset = this.dataSetTrans2;
            this.dataTableTrans2 = customfunctions.dynamicDataTable(dataItem);
          }
          else if (_colName == "Occupancy") {
            dataItem.dataTable = this.dataTableTrans3;
            dataItem.dataset = this.dataSetTrans3;
            this.dataTableTrans3 = customfunctions.dynamicDataTable(dataItem);
          }
          //Dynamic datable

          $($.fn.dataTable.tables(true)).DataTable().columns.adjust();


          $("#LoadingImagePopup").hide();

          $("#myModalTrans").show();

        }
        else {
          $("#LoadingImagePopup").hide();
          ngswal("Failed !", result.status, "warning");
        }

      }, error => {
        $("#LoadingImagePopup").hide();
        ngswal("Failed !", error.message, "warning");
      });

  }

  ResetDatatable() {
    try {

      if ($.fn.dataTable.isDataTable('#dataTables')) {
        $('#dataTables').DataTable().clear().destroy();
      }

      $('#dataTables').DataTable().clear().destroy();
      $('#DataTables_Table_0').DataTable().destroy();
      $('#DataTables_Table_0').empty();

    } catch (e) {
    }
  }


  GetDashboardLoad() {

    if ($('#ddlRange').val() == 'Yearly' && ($('#ddlFromYear').val() == '0' || $('#ddlToYear').val() == '0')) {
      ngswal("Failed !", 'Please select year', "warning");
    }
    else if ($('#ddlRange').val() == 'Monthly' && ($('#ddlFromMonth').val() == '0' || $('#ddlToMonth').val() == '0')) {
      ngswal("Failed !", 'Please select month', "warning");
    }
    else {
      if ($('#ddlRange').val() == 'Yearly') {
        customfunctions.SetDateValuesRangebased("#txtFromDt", "#txtToDt", $('#ddlRange').val(),
          $('#ddlFromYear').val(), $('#ddlToYear').val());
      }
      else if ($('#ddlRange').val() == 'Monthly') {
        customfunctions.SetDateValuesRangebased("#txtFromDt", "#txtToDt", $('#ddlRange').val(),
          $('#ddlFromMonth').val(), $('#ddlToMonth').val());
      }

      if ($('#ulTabList .nav-link.active')[0].name == 'kpi') {
        $('#divGraphPagination').show();
        this.FetchGraphDashboad();
      }
      else {
        $("#LoadingImage").show();

        var dataparam = {
          LoginId: localStorage.aLoginID,
          PublisherId: localStorage.aPubID,
          UserId: $('#ddlUserList').val(),
          ManagerId: $('#ddlBUHead').val(),
          ManagerId1: 0,
          RoleId: $('#ddlRole').val(),
          FromDate: $('#txtFromDt').val(),
          ToDate: $('#txtToDt').val(),
          Range: $('#ddlRange').val(),
          DepartmentId: $('#ddlDepartment').val(),
        };

        this.ResetDatatable();

        ApiMethod.postMethod('api/occupancydashboard', dataparam).subscribe(
          result => {
            $("#LoadingImage").hide();
            if (result.message = 'Success') {
            
              this.dataSet = JSON.stringify(result.dataList); // Data List
              this.dataSet = JSON.parse(this.dataSet);
              this.dataTable = $(this.table.nativeElement);

              this.dataSetPM = JSON.stringify(result.dataList); // Data List
              this.dataSetPM = JSON.parse(this.dataSetPM);
              this.dataTablePM = $(this.tablePM.nativeElement);

              try {

                //Dynamic datable
                let aColList = result.colList;
                let dataItem = new DataParam();
                dataItem.acolList = aColList;
                dataItem.dataTable = this.dataTable;
                dataItem.defaultPagesize = -1;
                dataItem.dataset = this.dataSet;
                dataItem.dtheight = (GlobalConstants.size.height - 250);
                dataItem.modulename = 'EmpOccupancyDashboard';
                dataItem.LengthChange = false;
                dataItem.colsetting = false;
                dataItem.infoPopupID = "Id";
                this.dataTable = customfunctions.dynamicDataTable(dataItem);
                //Dynamic datable}


                //Dynamic datable
                let aColListPM = result.colList1;
                let dataItemPM = new DataParam();
                dataItemPM.acolList = aColListPM;
                dataItemPM.dataTable = this.dataTablePM;
                dataItemPM.aNewButtonName = 'btnUploadExcel';
                dataItemPM.aNewButtonToolTip = 'Upload Attendance Excel file';
                dataItemPM.defaultPagesize = -1;
                dataItemPM.dataset = this.dataSetPM;
                dataItemPM.dtheight = (GlobalConstants.size.height - 250);
                dataItemPM.modulename = 'EmpOccupancy';
                dataItemPM.LengthChange = false;
                dataItemPM.colsetting = false;
                dataItemPM.infoPopupID = "Id";
                this.dataTablePM = customfunctions.dynamicDataTable(dataItemPM);
                //Dynamic datable}
              } catch (e) {

              }
            }
            else {
              ngswal("Failed !", result.message, "warning");
            }

          }, error => {
            $("#LoadingImage").hide();
            ngswal("Failed !", error.message, "warning");
          });
      }
    }
  }

  ShowFilterPanel() {
    $('#divFilterPanel').show();
  }
  HideFilterPanel() {
    $('#divFilterPanel').hide();
  }
  ExcelUploadZinghr() {
    $("#FilePackage").trigger("click");
  }

  UploadPackage = (files) => {
    if (files.length === 0) {
      return false;
    }
    let fileToUpload = <File>files[0];
    let ext = fileToUpload.name.toString().split('.').pop().toLowerCase();
    if ($.inArray(ext, ['xlsx']) == -1) {
      ngswal("Warning !", "Invalid file format upload Excel!", "warning");
      return false;
    }
    const formData = new FormData();
    formData.append('file', fileToUpload, fileToUpload.name);
    formData.append('ClientApiUrl', "api/ZingHRLeaveUpload");
    formData.append('LoginId', localStorage.aLoginID);
    formData.append('PublisherId', localStorage.aPubID);
    formData.append('ProcessType', "Upload");
    $("#LoadingImagePopup").show();

    ngswal({
      title: 'Please wait processing!.....',
      text: '',
      showCancelButton: false,
      showConfirmButton: false
    });
    let http = new HttpClient(new HttpXhrBackend({ build: () => new XMLHttpRequest() }));
    http.post($('base')[0].href + 'api/Endpoint/PostFileClient', formData).subscribe(
      (response: Response) => {

        let msgInfo = ''; let msgDetails = '';
        let result = $(response.headers);
        $.each(result, function (e, val) {
          if (val.key == 'ErrorMessage') {
            msgInfo = 'Warning';
            msgDetails = val.value.toString();
          }
          else if (val.key == 'SuccessMessage') {
            msgInfo = 'Success';
            msgDetails = val.value.toString();
          }
        });
        $('#FilePackage').val('');
        ngswal(msgInfo, msgDetails, "info");

        $("#LoadingImagePopup").hide();
      },
      (error) => {
        console.log(error.message);    // Show error, if any.
        ngswal("Warning !", error.message, "warning");
        $("#LoadingImagePopup").hide();
      }
    );
  }

  _thresholdRangeData: any = [];
  finalData: any = []; finalgraphHeading = 'Summary KPI';
  // KPI Graph Data
  FetchGraphDashboad() {

    this.startIndex = 0; this.endIndex = 15;
    $("#LoadingImage").show();

    var dataparam = {
      LoginId: localStorage.aLoginID,
      PublisherId: localStorage.aPubID,
      UserId: $('#ddlUserList').val(),
      ManagerId: $('#ddlBUHead').val(),
      ManagerId1: 0,
      RoleId: $('#ddlRole').val(),
      FromDate: $('#txtFromDt').val(),
      ToDate: $('#txtToDt').val(),
      Range: $('#ddlRange').val(),
      DepartmentId: $('#ddlDepartment').val(),
      DataName: ''
    };

    ApiMethod.postMethod('api/occupancygraphdash', dataparam).subscribe(
      result => {
        $("#LoadingImage").hide();
        let roleDataItem = result.roleDataList;
        let dataItem = result.empDataList;
        let rangeDataItem = result.rangeDataList;
        this._thresholdRangeData = result.thresholdRangeData;
        this.finalgraphHeading = 'Employee KPI';
        if ($('#ddlBUHead').val() == '0') {
          dataItem = roleDataItem;
          this.finalgraphHeading = 'Summary KPI';
        }

        if ($('#ddlUserList').val() != '0') {
          dataItem = rangeDataItem;
          this.finalgraphHeading = 'Employee KPI';
        }

        this.finalData = dataItem;
        this.UpdatePaginationButtons();
        this.GenerateGraphData(dataItem);
      }, error => {
        $("#LoadingImage").hide();
        ngswal("Failed !", error.message, "warning");
      });
  }

  GenerateGraphData(data) {

    if (typeof data === 'undefined' || data == null) {
      return;
    }

    $("#LoadingImage").show();

    let dataItem = data;

    if (this.endIndex == 0) {
      this.endIndex = dataItem.length;
    }
    if (data.length > 0) {
      dataItem = dataItem.slice(this.startIndex, this.endIndex);
    }
    //Emp Kpi Dashboard
    let chartColCategory: any = []; let chartColSeriesList: any = [];
    $(dataItem).each(function (index, val) {
      chartColCategory.push(val.DataName);
    });

    let _overAll: any = [];
    let _productivtyAchieved: any = []; let _occupancy: any = []; let _punctuality: any = []; let _attendance: any = [];
    $(dataItem).each(function (index, val) {
      _productivtyAchieved.push({
        name: val.DataName, y: val.ProductivtyAchieved,
        PoorRange: val.PoorRange, ModerateRange: val.ModerateRange, GoodRange: val.GoodRange, ExcellentRange: val.ExcellentRange
      });
      _occupancy.push({
        name: val.DataName, y: val.Occupancy,
        PoorRange: val.PoorRange, ModerateRange: val.ModerateRange, GoodRange: val.GoodRange, ExcellentRange: val.ExcellentRange
      });
      _punctuality.push({
        name: val.DataName, y: val.Punctuality,
        PoorRange: val.PoorRange, ModerateRange: val.ModerateRange, GoodRange: val.GoodRange, ExcellentRange: val.ExcellentRange
      });
      _attendance.push({
        name: val.DataName, y: val.Attendance,
        PoorRange: val.PoorRange, ModerateRange: val.ModerateRange, GoodRange: val.GoodRange, ExcellentRange: val.ExcellentRange
      });
      _overAll.push({
        name: val.DataName, y: val.TotalSum,
        PoorRange: val.PoorRange, ModerateRange: val.ModerateRange, GoodRange: val.GoodRange, ExcellentRange: val.ExcellentRange
      });
    });

    this._empachieved.LoadColChartData(chartColCategory, _productivtyAchieved, 'Productivty', this._thresholdRangeData);
    this._empoccupancy.LoadColChartData(chartColCategory, _occupancy, 'Occupancy', this._thresholdRangeData);
    this._emppunctuality.LoadColChartData(chartColCategory, _punctuality, 'Punctuality', this._thresholdRangeData);
    this._empattendance.LoadColChartData(chartColCategory, _attendance, 'Attendance', this._thresholdRangeData);
    this._empoverall.LoadColChartData(chartColCategory, _overAll, 'Overall', this._thresholdRangeData);

    chartColSeriesList.push({
      name: 'Productivty',
      data: _productivtyAchieved,
      color: '#00766f',
      dataLabels: {
        enabled: true,
        color: '#000',
        format: '{point.y} %'
      }
    });
    chartColSeriesList.push({
      name: 'Occupancy',
      data: _occupancy,
      color: '#544fc5',
      dataLabels: {
        enabled: true,
        color: '#000',
        format: '{point.y} %'
      }
    });
    chartColSeriesList.push({
      name: 'Punctuality',
      data: _punctuality,
      color: '#3194fd',
      dataLabels: {
        enabled: true,
        color: '#000',
        format: '{point.y} %'
      }
    });
    chartColSeriesList.push({
      name: 'Attendance',
      data: _attendance,
      color: '#1c74bd',
      dataLabels: {
        enabled: true,
        color: '#000',
        format: '{point.y} %'
      }
    });

    this.LoadColChartData(chartColCategory, chartColSeriesList, this.finalgraphHeading);

    $("#LoadingImage").hide();
  }

  //EmpKPI Chart
  highchartsCol: typeof Highcharts = Highcharts; chartOptionsCol;
  LoadColChartData(categoryList, chartSeriesList, graphHeading) {
    //Column Chart
    this.highchartsCol = Highcharts;
    this.chartOptionsCol = {
      chart: {
        type: 'column',
        style: {
          fontFamily: 'Poppins, Arial, sans-serif',
        },
      },
      title: {
        text: graphHeading,
      },
      xAxis: {
        categories: categoryList,
        type: 'category',
      },
      yAxis: {
        title: {
          text: 'Values',
        }
      },
      plotOptions: {
        series: {
          /* stacking: 'normal',*/
          dataLabels: {
            enabled: true,
          },
        },
      },
      tooltip: {
        headerFormat: '<span style="font-size:10px">{point.key}</span><table>',
        pointFormat:
          '<tr><td style="color:{series.color};padding:0">{series.name}: </td>' +
          '<td style="padding:0"><b>{point.y}</b></td></tr>',
        footerFormat: '</table>',
        shared: true,
        useHTML: true,
      },
      series: chartSeriesList,
      exporting: {
        enabled: true // Enables the export button
      }
    };
  }

  currentPage: number = 0;
  itemsPerPage: number = 15;
  startIndex = 1; endIndex = 15;

  NextPageData(): void {
    const totalPages = Math.ceil(this.finalData.length / this.itemsPerPage);
    if (this.currentPage < totalPages - 1) {
      this.currentPage++;
      this.startIndex = this.currentPage * this.itemsPerPage;
      this.endIndex = this.startIndex + this.itemsPerPage;
      this.GenerateGraphData(this.finalData);
      this.UpdatePaginationButtons();
    }
  }

  PreviousPageData(): void {
    try {
      if (this.currentPage > 0) {
        this.currentPage--;
        this.startIndex = this.currentPage * this.itemsPerPage;
        this.endIndex = this.startIndex + this.itemsPerPage;
        this.GenerateGraphData(this.finalData);
        this.UpdatePaginationButtons();
      }
    } catch (e) {

    }
  }

  UpdatePaginationButtons(): void {
    try {
      const totalPages = Math.ceil(this.finalData.length / this.itemsPerPage);

      const prevButton = document.getElementById('prevButton') as HTMLButtonElement;
      const nextButton = document.getElementById('nextButton') as HTMLButtonElement;

      // Disable the "Previous" button if on the first page
      prevButton.disabled = this.currentPage === 0;

      // Disable the "Next" button if on the last page
      nextButton.disabled = this.currentPage === totalPages - 1;

    } catch (e) {

    }
  }


}
